import { FormEventHandler, useState, useEffect } from "react";
import useAuth from "hooks/useAuth";
import { Link, useNavigate, useLocation } from "react-router-dom";

import axios from "utils/axios";
import jwtDecode from "jwt-decode";
import { Alert, Checkbox } from "@material-tailwind/react";

export default function Login() {

  const { setAuth, setPersist, persist } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errMsg, setErrMsg] = useState('');

  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || "/";

  useEffect(() => {
      setErrMsg('');
  }, [email, password])

  const handleSubmit : FormEventHandler = async(e)=>{
    e.preventDefault();

    try {
        const response = await axios.post('/auth/login', JSON.stringify({email, password}), {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        })

        console.log(response)

        const decodedRes : any = jwtDecode(response.data)
        const accessToken = response.data;
        const resemail = decodedRes.email;
        const isAdmin = decodedRes.isAdmin;
        const name = decodedRes.name;
        const id = decodedRes.sub;
        setAuth({name ,accessToken, email : resemail, isAdmin,id});
        setEmail('');
        setPassword('');
        navigate(from, { replace: true });
    } catch (err:any) {
        if (!err?.response) {
            setErrMsg('No Server Response');
        } else if (err.response?.status === 400) {
            setErrMsg('Missing email or Password');
        } else if (err.response?.status === 401) {
            setErrMsg('Invalid email / Password');
        } else {
            setErrMsg('Something Went Wrong');
        }
    }
    
  }
  return (
    <>
      <div className="container mx-auto px-4 h-screen relative">
        <div className="">
          <div className="absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 z-[-1]" style={{boxShadow: '#00000011 10px -6px 400px 200px'}}></div>
        </div>
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-4/12 px-4 relative">
            {( errMsg &&
              <Alert color="red" className=" absolute bottom-[calc(100%+0.5rem)] w-[93%] shadow-md">
                {errMsg}
              </Alert>
            )}
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-slate-200 border-0">
              <div className="flex-auto px-4 lg:px-10 py-10 pt-0 bg-white">
                <div className="text-slate-400 text-xl text-center mb-3 font-bold mt-8">
                  <small>Sign In</small>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-slate-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Email
                    </label>
                    <input
                      type="email"
                      className="input w-full rounded-md"
                      placeholder="Email"
                      onChange={(e)=>setEmail(e.target.value)}
                      value={email}
                      required
                    />
                  </div>

                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-slate-600 text-xs font-bold mb-2"
                      htmlFor="grid-password"
                    >
                      Password
                    </label>
                    <input
                      type="password"
                      className="input w-full rounded-md"
                      placeholder="Password"
                      onChange={(e)=>setPassword(e.target.value)}
                      value={password}
                      required
                    />
                  </div>

                  <div className="relative -left-2">
                  <Checkbox checked={persist} onChange={(e)=>{setPersist(e.target.checked)}} label="Trust this device ?"></Checkbox>
                  </div>

                  <div className="text-center mt-6">
                    <button
                      className="bg-slate-800 text-white active:bg-slate-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150"
                      type="submit"
                    >
                      Sign In
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className="flex flex-wrap mt-6 relative">
              <div className="w-1/2 text-left">
                <Link to="/" className="text-slate-700">
                  <small>Back to home</small>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
